
import { formatDate } from "@angular/common";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { environment } from "apps/website/src/environments/environment";
import { BehaviorSubject, map, Observable, Subject, throwError } from "rxjs";
import Swal from "sweetalert2";
import {
  Country,
  HttpResponse,
  Industry,
  ManagerList,
  ProfileDetail,
  RoleDetail,
  ProjectListTs,
  ProjectActivityDetail,
  ProjectActivityListDetail,
  ActivityListTs
} from "../interfaces";
import { SnackbarEnum } from "../public-api";
import { UserHttpService } from "./user-session.service";
import { FirebaseMessagingService } from "./firebase-messaging.service";
import { Location } from "@angular/common";

const assetsPathUrl = environment.assetsPathUrl

@Injectable({
  providedIn: "root",
})
export class CommonWebService {
  public countrListy$: Subject<Country[]> = new Subject<Country[]>();
  public roleList$: Subject<RoleDetail[]> = new Subject<RoleDetail[]>();
  public industryList$: Subject<Industry[]> = new Subject<Industry[]>();
  public managersList$: Subject<ManagerList[]> = new Subject<any[]>();
  public projectActivity$: Subject<ProjectActivityListDetail[]> = new Subject<ProjectActivityListDetail[]>();
  public timesheetActivity$: Subject<ActivityListTs[]> = new Subject<ActivityListTs[]>();
  public profileDetail$: Subject<ProfileDetail> = new Subject<ProfileDetail>();
  public timezone$: Subject<string[]> = new Subject<string[]>();
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public hoursArray: number[] = Array.from({ length: 24 }, (_, i) => i);

  public minsArray: number[] = Array.from({ length: 60 }, (_, i) => i).filter(i => [0, 15, 30, 45].includes(i));
  //public minsArray: number[] = [];

  constructor(
    private snackbar: MatSnackBar,
    private http: HttpClient,
    private userSessionService: UserHttpService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private location: Location,
    private firebaseMessagingService: FirebaseMessagingService
  ) { }

  public getMinArray() {
    for (let i = 0; i < 59; i++) {
      this.minsArray.splice(i, 0, i + 1);
    };
    return this.minsArray;
  }

  public setHeaders(isJson = true) {
    const headers = {
      "Access-control-allow-origin": "*",
    };

    if (isJson) {
      Object.assign(headers, { "Content-type": "application/json" });
    }

    return new HttpHeaders(headers);
  }

  public handleError(error: HttpErrorResponse) {
    let errMessage: any;
    if (error.error instanceof ErrorEvent) {
      errMessage = `${error.error.message ? error.error.message : "Please try again later..."
        }`;
    } else {
      errMessage = `${error.error.message ? error.error.message : "Please try again later..."
        }`;
    }
    return throwError(() => errMessage);
  }

  SanitizedHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  logout(error: boolean = false) {
    this.firebaseMessagingService.unregister();

    localStorage.removeItem("intrasense-user:session");
    localStorage.removeItem("intrasense-user:token");
    sessionStorage.removeItem("intrasense-user:session");
    sessionStorage.removeItem("intrasense-user:token");

    if (error) {
      return this.router.navigate(['/error', 401]);
    } else {
      return this.router.navigate(['/']);
    }
  }

  //get industries
  public getAllIndustries() {
    this.http.get<HttpResponse<Industry[]>>("common/industryList").subscribe({
      next: (res) => {
        this.industryList$.next(res.data.length > 0 ? res.data : []);
      },
      error: (err) => {
        console.log(err);
        this.openSnackbar(err, SnackbarEnum.ERROR);
      },
    });
  }

  //get countries
  public getAllCountries() {
    this.http.get<HttpResponse<Country[]>>("common/countryList").subscribe({
      next: (res) => {
        this.countrListy$.next(res.data.length > 0 ? res.data : []);
      },
      error: (err) => {
        console.log(err);
        this.openSnackbar(err, SnackbarEnum.ERROR);
      },
    });
  }

  //get countries
  public getTimezones() {
    this.http.get<HttpResponse<string[]>>("meeting/timezoneList").subscribe({
      next: (res) => {
        this.timezone$.next(res.data.length > 0 ? res.data : []);
      },
      error: (err) => {
        console.log(err);
        this.openSnackbar(err, SnackbarEnum.ERROR);
      },
    });
  }

  //get employees
  public getAllEmployeeRoles() {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append(
      "usr_role_track_id",
      this.userSessionService.getUserInfo.usr_role_track_id
    );
    formData.append("token", this.userSessionService.userToken);
    this.http
      .post<HttpResponse<RoleDetail[]>>("roles/roleList", formData)
      .subscribe({
        next: (res) => {
          this.roleList$.next(res.data.length > 0 ? res.data : []);
        },
        error: (err) => {
          console.log(err);
          this.openSnackbar(err, SnackbarEnum.ERROR);
        },
      });
  }

  //getmanagerlist
  public getAllManagersList() {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append(
      "customer_id",
      this.userSessionService.getUserInfo.usr_customer_track_id
    );
    formData.append("token", this.userSessionService.userToken);
    this.http
      .post<HttpResponse<ManagerList[]>>("employees/pmList", formData)
      .subscribe({
        next: (res) => {
          this.managersList$.next(res.data.length > 0 ? res.data : []);
        },
        error: (err) => {
          console.log(err);
          this.openSnackbar(err, SnackbarEnum.ERROR);
        },
      });
  }

  //get project acitivities list
  public getProjectActivities(limit?: number, offset?: number) {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    if (limit !== undefined) {
      formData.append("limit", limit.toString());
    }
    if (offset !== undefined) {
      formData.append("offset", offset.toString());
    }
    this.http.post<HttpResponse<any>>("projects/projectActivityTypeList", formData).subscribe({
      next: ((res) => {
        if (res.data.data && res.data.data.length > 0) { //In case of pagination to display data in tabular form
          this.projectActivity$.next(res.data);
        } else {// For dropdown data
          this.projectActivity$.next(res.data.length > 0 ? res.data : []);
        }
      }),
      error: ((err) => {
        console.log(err);
        this.openSnackbar(err, SnackbarEnum.ERROR);
      }),
    });
  }

  //get timesheet acitivities list
  public getTimesheetActivities() {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    this.http.post<HttpResponse<ActivityListTs[]>>("timesheet/timeSheetActivityList", formData).subscribe({
      next: ((res) => {
        this.timesheetActivity$.next(res.data.length > 0 ? res.data : []);
      }),
      error: ((err) => {
        console.log(err);
        this.openSnackbar(err, SnackbarEnum.ERROR);
      }),
    });
  }

  //getmanagerlist
  public getProfileDetail() {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("token", this.userSessionService.userToken);
    this.http
      .post<HttpResponse<ProfileDetail[]>>("setting/profile", formData).pipe(
        map((response) => {
          if (response && response.data && response.data[0]) {
            response.data[0].usr_dob = response.data[0].usr_dob && response.data[0].usr_dob !== '0000-00-00' ? response.data[0].usr_dob : '';
            response.data[0].aniversary = response.data[0].aniversary && response.data[0].aniversary !== '0000-00-00' ? response.data[0].aniversary : '';
            response.data[0].joining = response.data[0].usr_dob && response.data[0].joining !== '0000-00-00' ? response.data[0].joining : '';
            return response;
          } else {
            return response
          }
        })
      ).subscribe({
        next: (res) => {
          this.profileDetail$.next(res.data[0]);
        },
        error: (err) => {
          console.log(err);
          Swal.fire("Oops...", err, "error");
        },
      });
  }

  //get emmployee Manager List
  public uploadImage(image: any): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("picture", image ? this.getFormattedImageBase64(image) : '');
    return this.http.post<HttpResponse<any>>("common/images", formData);
  }

  openSnackbar(message: string, color?: SnackbarEnum) {
    this.snackbar.open(message ? message : "Something went wrong!", "Close", {
      duration: 2000,
      panelClass: [color && color == SnackbarEnum.SUCCESS ? "green-snackbar" : color && color == SnackbarEnum.ERROR ? "error-snackbar" : color && color == SnackbarEnum.INFO ? "info-snackbar" : 'white-snackbar']
    });
  }

  //format date
  public changeDateFormat(date: Date) {
    return formatDate(date, "yyyy-MM-dd", "en-auto");
  }

  public changeToISOstring(value: string) {
    let data = value.split(" ");
    let date = data[0] + "T" + data[1] + "Z";
    return date;
  }

  //format image
  getFormattedImageBase64(base64: string, insidePath?: string) {
    if (base64) {
      if (base64.includes('data:image/jpeg;base64,')) {
        return base64.split('data:image/jpeg;base64,')[1] ? base64.split('data:image/jpeg;base64,')[1] : base64;
      } else if (base64.includes('data:image/svg+xml;base64,')) {
        return base64.split('data:image/svg+xml;base64,')[1] ? base64.split('data:image/svg+xml;base64,')[1] : base64;
      } else if (base64.includes('data:image/png;base64,')) {
        return base64.split('data:image/png;base64,')[1] ? base64.split('data:image/png;base64,')[1] : base64;
      } else if (base64.includes('data:application/pdf;base64,')) {
        return base64.split('data:application/pdf;base64,')[1] ? base64.split('data:application/pdf;base64,')[1] : base64;
      } else if (base64.includes('data:application/msword;base64,')) {
        return base64.split('data:application/msword;base64,')[1] ? base64.split('data:application/msword;base64,')[1] : base64;
      } else if (base64.includes('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,')) {
        return base64.split('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,')[1]
          ? base64.split('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,')[1]
          : base64;
      } else if (base64.includes('data:application/vnd.ms-powerpoint;base64,')) {
        return base64.split('data:application/vnd.ms-powerpoint;base64,')[1] ? base64.split('data:application/vnd.ms-powerpoint;base64,')[1] : base64;
      } else if (base64.includes('data:application/vnd.ms-excel;base64,')) {
        return base64.split('data:application/vnd.ms-excel;base64,')[1] ? base64.split('data:application/vnd.ms-excel;base64,')[1] : base64;
      } else if (base64.includes('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,')) {
        return base64.split('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,')[1]
          ? base64.split('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,')[1]
          : base64;
      } else if (base64.includes(assetsPathUrl) && !insidePath) {
        return base64.split(assetsPathUrl)[1]
      } else if (base64.includes(assetsPathUrl) && insidePath) {
        return base64.split(`${assetsPathUrl}${insidePath}`)[1];
      } else {
        return base64;
      }
    } else {
      return '';
    }
  }

  getHourFormattedValue(value: number | string) {
    if (value) {

      return Math.trunc(Number(value) / 60);
    } else {
      return "";
    }
  }

  getMinFormattedValue(value: number | string) {
    if (value) {
      return Math.trunc(Number(value) % 60);
    } else {
      return "";
    }
  }

  /*--Generate Finincial year dropdown options--*/
  generateFinancialYearOptions(startYear: number, numberOfYears: number): string[] {
    const options: string[] = [];

    for (let i = 0; i < numberOfYears; i++) {
      const yearStart = startYear + i;
      const yearEnd = yearStart + 1;
      const financialYear = `${yearStart}-${yearEnd}`;
      options.push(financialYear);
    }

    return options;
  }

  /*--Function to go to previous url--*/
  public goBack(): void {
    this.location.back();
  }

  /*--Funciton to autoselect the value from mat select when typed in the input box of mat select--*/
  // public validateAutocompleteSelection(
  //   control: any,
  //   options: any[],
  //   matchKey: string
  // ): void {
  //   let inputValue = '';
  //   if (typeof control.value === 'string') {
  //     inputValue = control.value.toLowerCase().trim();
  //     const match = options.find(item => {
  //       const value = item?.[matchKey];
  //       return typeof value === 'string' && value.toLowerCase().includes(inputValue);
  //     });

  //     if (match) {
  //       control.setValue(match);  // auto-select first match
  //       control.setErrors(null);
  //     } else {
  //       control.setErrors({ notInList: true });  // show error
  //     }
  //   } else if (typeof control.value === 'object' && control.value !== null) {
  //     // Assume it's a valid object from dropdown
  //     control.setErrors(null);  // clear errors
  //   } else {
  //     control.setErrors({ notInList: true }); // invalid input
  //   }
  // }

  public validateAutocompleteSelection(
    control: any,
    options: any[],
    matchKey: string
  ): void {
    let inputValue = '';
    if (typeof control.value === 'string') {
      inputValue = control.value.toLowerCase().trim();
      if (!inputValue) {
        // Don't auto-select anything on empty input
        control.setErrors({ notInList: true });
        return;
      }

      const match = options.find(item => {
        const value = item?.[matchKey];
        return typeof value === 'string' && value.toLowerCase().includes(inputValue);
      });
      if (match) {
        control.setValue(match);  // auto-select first match
        control.setErrors(null);
      } else {
        control.setErrors({ notInList: true });  // show error
      }
    } else if (typeof control.value === 'object' && control.value !== null) {
      // Assume it's a valid object from dropdown
      control.setErrors(null);  // clear errors
    } else {
      control.setErrors({ notInList: true }); // invalid input
    }
  }
  /*--Format time to AM/PM--*/
  formatTimeToAMPM(timeStr: string): string {
    if (!timeStr) return '';
    const [hourStr, minuteStr] = timeStr.split(':');
    const hours = parseInt(hourStr, 10);
    const minutes = parseInt(minuteStr, 10);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
  }

  /*--Disable dates less than or equal to start date--*/
  disablePreviousDatesFilter(form: any, startControlName: string) {
    return (date: Date | null) => {
      const start = form.get(startControlName)?.value;
      if (!date || !start) return true;

      const startDate = new Date(start).setHours(0, 0, 0, 0);
      const currentDate = new Date(date).setHours(0, 0, 0, 0);

      return currentDate >= startDate;
    };
  }

  /*--Reset To Date if the To Date is less than From date--*/
  resetToDate(form: any, startControlName: string, endControlName: string) {
    const start = form.get(startControlName)?.value;
    const end = form.get(endControlName)?.value;
    if (start && end && start > end) {
      form.get(endControlName)?.setValue(start);
    }
  }

  /*--Remove br from string and add new line--*/
  cleanStringOutput(comment: string): string {
    if (!comment) return '';
    return comment
      .replace(/<br\s*\/?>/gi, '\r\n');   // replace <br>, <br/>, <br /> with newline
  }
}


